import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-amber-500" data-id="element-132">
      <div className="max-w-3xl mx-auto text-center" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-134">
          <ShieldCheck className="w-20 h-20 text-slate-950 mx-auto mb-6" data-id="element-135" />
          <h2 className="text-4xl md:text-5xl font-black text-slate-950 mb-6 uppercase tracking-tight" data-id="element-136">
            GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>
          <div className="text-xl md:text-2xl text-slate-900 font-medium space-y-4" data-id="element-137">
            <p data-id="element-138">Abrís los tomos. Los usás en casa.</p>
            <p data-id="element-139">Si en 7 días no es exactamente lo que esperabas:</p>
            <p className="text-3xl md:text-4xl font-black bg-slate-950 text-amber-400 inline-block px-6 py-2 rounded-xl my-4 transform -rotate-1" data-id="element-140">
              devolución del 100%
            </p>
            <p className="font-bold" data-id="element-141">
              sin formularios, sin drama, sin explicaciones.
            </p>
            <p className="text-sm text-slate-800 mt-8 font-bold" data-id="element-142">
              Tasa de devoluciones: menos del 1%.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}